import {
  Box,
  Field,
  FieldControl,
  FieldIcon,
  FieldLabel,
  Switch,
  Text
} from "@prismicio/editor-ui"
import type { BooleanContent } from "@prismicio/types-internal/lib/content"
import type { BooleanField as BooleanT } from "@prismicio/types-internal/lib/customtypes"

import { getBooleanFieldPlaceholder, getFieldLabel } from "./utils"

interface Props {
  content: BooleanContent | undefined
  field: BooleanT
  id: string
  readOnly: boolean
  onContentChange: (content: BooleanContent) => void
}

export function BooleanField(props: Props) {
  const { content, field, id, readOnly, onContentChange } = props

  const checked = content?.value ?? field.config?.default_value ?? false

  return (
    <Field>
      <FieldIcon name="biToggle" />
      <FieldLabel htmlFor={id}>{getFieldLabel(field)}</FieldLabel>
      <FieldControl>
        <Box padding={4} alignItems="center">
          <Text>{getBooleanFieldPlaceholder(field, checked)}</Text>
        </Box>
        <Switch
          id={id}
          sx={{ alignSelf: "center", marginLeft: "auto", marginRight: 12 }}
          checked={checked}
          onCheckedChange={(checked) => {
            if (!readOnly) onContentChange(updateContent(checked))
          }}
        />
      </FieldControl>
    </Field>
  )
}

function updateContent(value: boolean): BooleanContent {
  return { __TYPE__: "BooleanContent", value }
}
